import { render, staticRenderFns } from "./contact10.vue?vue&type=template&id=6923ac62&scoped=true"
import script from "./contact10.vue?vue&type=script&lang=js"
export * from "./contact10.vue?vue&type=script&lang=js"
import style0 from "./contact10.vue?vue&type=style&index=0&id=6923ac62&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6923ac62",
  null
  
)

export default component.exports